import type { FaireProductEntity } from "../../entity_types/product";

export const p_cgjdjphzzz: FaireProductEntity = {
  token: "p_cgjdjphzzz",
  type: "product",
  name: "Dried Flowers - Field Bouquet - Orange",
  brandToken: "b_4qm8pqu56k",
  brandName: "Wildflowers by Floriette",
  imageUrl:
    "https://cdn.faire.com/fastly/2f8f999f4f89ddad1c9239fd4d7f1c39b73a5608f1cbed443bbe0f16e351db20.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5715c296eb15044db78e0f27cf73d5a6d68111834186d68de05146518733c496.jpeg",
    "https://cdn.faire.com/fastly/9c3a75f3e3f8dc1787229e46851425bc27a9ef99b5c999f99143d8565c9fcb02.jpeg",
    "https://cdn.faire.com/fastly/f09fd9f1c553664d795375dc10344db15c3573d8a9719028f12f7f26048baeea.jpeg",
    "https://cdn.faire.com/fastly/bb6a4de3bb9d913816124d618ecfbcda68b73734c1e66166633aa12444de0403.jpeg",
    "https://cdn.faire.com/fastly/b74f13667607a65ff044d43ac1536c6e7824c0f1aaa6b8eb2871ad91faf68ae6.jpeg",
    "https://cdn.faire.com/fastly/f2a91236477993aac608aaed04f1be62bdc055e6da413b1475c51640a7c70155.jpeg",
  ],
  priceDollars: 15,
  description:
    "Introducing our exquisite Dried Flowers Field Bouquet Orange. Enrich your space with the beauty of dried flowers, carefully handcrafted and sustainably grown for a touch of eco-conscious elegance. Each piece is thoughtfully curated with love, resulting in a stunning composition that captures the essence of natural beauty. These charming bouquets are also available in Small, Medium and Large.\n\nPlease note that dried flowers are natural and seasonal products, which may lead to variations in flower types and colors compared to the photo. Embrace the surprises that come with these ever-changing botanical wonders and add a touch of enchantment to any environment.\n\nSmall: 35 cm\nMedium: 50 cm\nLarge: 60 cm",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:41.001Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
